import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import RegisterButton from './components/RegisterButton';
import store from './redux/store';
import { AuthProvider } from './utils/context';

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </Provider>
  );
}

function AppContent() {
  const location = useLocation();

  const isAdminRoute =
    location.pathname.includes('/admin') ||
    location.pathname.includes('/login');

  return (
    <>
      {!isAdminRoute && <RegisterButton />}
      <AppRoutes />
    </>
  );
}

export default App;
